<template>
    <img v-if="allowed" :src="src" :alt="alt" @error="$emit('error', $event)" />
    <button
        v-else
        type="button"
        class="external-image-placeholder"
        @click="consentStore.set('external')"
    >
        <span class="material-symbols-outlined">image</span>
        <span>Allow external images and maps</span>
    </button>
</template>

<script>
import { useConsentStore } from "js/stores/consentStore.js";
import { isExternalHost } from "js/lib/externalHosts.js";

export default {
    name: "ExternalImage",
    props: {
        src: {
            type: String,
            default: "",
        },
        alt: {
            type: String,
            default: "",
        },
    },
    emits: ["error"],
    data() {
        return {
            consentStore: useConsentStore(),
        };
    },
    computed: {
        allowed() {
            return (
                !isExternalHost(this.src) || this.consentStore.externalAllowed
            );
        },
    },
};
</script>
